import { keys, forEach } from 'ramda';

export default function injectDependencies(statics, dynamic = {}) {
  return ({ dispatch, getState }) => next => action => {
    if (typeof action !== 'function') return next(action);
    const dependencies = { ...statics };

    forEach(key => {
      dependencies[key] = dynamic[key](getState());
    }, keys(dynamic));

    return dispatch(action({ ...dependencies, getState, dispatch }));
  };
}
